import { Reservation } from "../models/StaticDataModel";

export const getRoomTypeDescription = (reservation: Reservation): string => {
  return reservation.roomTypeInformation?.roomDescription ?? "";
};